import React from "react";

import Avatar from "@components/tailwindComponents/Avatar";
import CheckboxSimple from "@components/tailwindComponents/CheckboxSimple";
import DotLoader from "@components/tailwindComponents/DotLoader";
import EmptyData from "@components/tailwindComponents/EmptyData";
import Status from "@components/tailwindComponents/Status";
import BlackTooltip from "@components/tooltip/BlackTooltip";

import { defaultUserImage } from "@utils/data";

export default function CheckableEmployeeList({
  t,
  loading,
  filteredEmploye,
  employeSelected,
  selectAllEmploye,
  selectEmploye
}) {
  return (
    <div className="arh-h-[601px] arh-w-3/5 arh-overflow-y-auto">
      <table className="arh-relative arh-w-full arh-table-fixed">
        <thead className="arh-sticky arh-top-0 arh-z-[5] arh-bg-greyColor">
          <tr>
            <th className="arh-flex arh-max-w-[12.25rem] arh-items-center arh-px-4 arh-py-4 arh-font-poppins arh-text-[0.813rem] arh-font-semibold arh-text-black">
              <CheckboxSimple
                id="1"
                name="Employé"
                onClick={selectAllEmploye}
                checked={
                  !loading &&
                  filteredEmploye &&
                  filteredEmploye.length > 0 &&
                  employeSelected?.length === filteredEmploye.length
                }
                haveHover={false}
              />
              <span className="arh-ml-3">{t("Employé")}</span>
            </th>
            <th className="arh-max-w-[12.25rem] arh-px-7 arh-font-poppins arh-text-[0.813rem] arh-font-semibold arh-text-black desktop-middle:arh-px-4">
              {t("Emplacement")}
            </th>
            <th className="arh-max-w-[10rem] arh-px-7 arh-font-poppins arh-text-[0.813rem] arh-font-semibold arh-text-black desktop-middle:arh-px-4">
              {t("Groupe")}
            </th>
            <th className="arh-max-w-[14.5rem] arh-px-7 arh-font-poppins arh-text-[0.813rem] arh-font-semibold arh-text-black desktop-middle:arh-max-w-[6.25rem] desktop-middle:arh-px-4">
              {t("Statut")}
            </th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td
                colSpan={4}
                className="arh-h-[40dvh]"
              >
                <DotLoader size="small" />
              </td>
            </tr>
          ) : !filteredEmploye?.length ? (
            <tr>
              <td colSpan={4}>
                <EmptyData>{t("Aucun élément")}</EmptyData>
              </td>
            </tr>
          ) : (
            filteredEmploye?.map((employe) => {
              return (
                <tr
                  key={employe?._id}
                  className="arh-border arh-border-x-0 arh-border-t-0 arh-border-solid arh-border-b-[#ECEDEF] hover:arh-bg-greyColor"
                >
                  <td className="arh-flex arh-items-center arh-space-x-3 arh-overflow-x-hidden arh-px-4 arh-py-4 arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
                    <CheckboxSimple
                      id={employe?._id}
                      name="Employé"
                      onClick={(e) => {
                        selectEmploye(employe);
                      }}
                      checked={employeSelected?.some(
                        (o) => o._id === employe?._id
                      )}
                      haveHover={false}
                    />

                    <Avatar
                      src={employe?.images[0]?.location || defaultUserImage}
                      name={employe?.personnalInformation?.name}
                      textStyle="arh-max-w-[6.25rem] arh-font-poppins arh-font-medium arh-text-xs arh-text-black arh-truncate"
                      parentAvatar="arh-min-w-0"
                    />
                  </td>
                  <td className="arh-max-w-[12.25rem] arh-overflow-x-hidden arh-px-7 arh-font-poppins arh-text-xs arh-font-medium arh-text-black desktop-middle:arh-px-4">
                    <BlackTooltip
                      title={employe?.emplacement?.employeeEmplacement[0]?.name}
                      placement="top-start"
                    >
                      <span className="arh-block arh-w-full arh-truncate desktop-middle:arh-max-w-[8rem]">
                        {employe?.emplacement?.employeeEmplacement[0]?.name}
                      </span>
                    </BlackTooltip>
                  </td>
                  <td className="arh-max-w-[10rem] arh-overflow-x-hidden arh-px-7 arh-font-poppins arh-text-xs arh-font-medium arh-text-black desktop-middle:arh-px-4">
                    <BlackTooltip
                      title={employe?.groupsName ?? "Aucun"}
                      placement="top-start"
                    >
                      <span className="arh-block arh-w-full arh-truncate">
                        {employe?.groupsName ?? "Aucun"}
                      </span>
                    </BlackTooltip>
                  </td>
                  <td className="arh-max-w-[14.5rem] arh-px-7 arh-font-poppins arh-text-xs arh-font-medium arh-text-black desktop-middle:arh-max-w-[6.25rem] desktop-middle:arh-px-4">
                    <BlackTooltip
                      title={t(employe?.status)}
                      placement="top-start"
                    >
                      <div className="arh-flex arh-w-full arh-items-center arh-justify-between">
                        <span className="arh-w-full arh-truncate desktop-middle:arh-max-w-[54px]">
                          {t(employe?.status)}
                        </span>
                        <Status
                          className={
                            (employe?.status === "Actif" &&
                              "arh-bg-dotGreen") ||
                            (employe?.status === "Inactif Temporairement" &&
                              "arh-bg-dotYellow") ||
                            "arh-bg-dotRed"
                          }
                        />
                      </div>
                    </BlackTooltip>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
